import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/footer";
import Navbar from "./components/navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Banking from "./pages/banking";
import Contact from "./pages/contact";
import Gallery from "./pages/gallery";
import Home from "./pages/home";
import Login from "./pages/login";
import NewUser from "./pages/new-user";
import PageNotFound from "./pages/pageNotFound";
import Privacy from "./pages/privacy";
import Signup from "./pages/signup";
import SingleTeam from "./pages/single-team";
import SingleUser from "./pages/single-user";
import SingleBanking from "./pages/singleBanking";
import SinglePageGallery from "./pages/singlePageGallery";
import SingleStartup from "./pages/singleStartup";
import SingleSubsidy from "./pages/singleSubsidy";
import SingleTaxation from "./pages/singleTaxation";
import Startup from "./pages/startup";
import Subsidy from "./pages/subsidy";
import Taxation from "./pages/taxation";
import Team from "./pages/team";
import TeamCustomer from "./pages/team-customer";
import WebAdmin from "./pages/web-admin";

function App() {
  const [showMobileMenu, setshowMobileMenu] = useState(false);

  return (
    <div className="App">
      <Navbar
        showMobileMenu={showMobileMenu}
        setshowMobileMenu={setshowMobileMenu}
      />
      <Routes>
        <Route path="/consultancy" element={<Taxation />} />
        <Route path="/startup" element={<Startup />} />
        <Route path="/banking/:service" element={<SingleBanking />} />
        <Route path="/consultancy/:service" element={<SingleTaxation />} />
        <Route path="/banking" element={<Banking />} />
        <Route path="/startup/:service" element={<SingleStartup />} />
        <Route path="/subsidy" element={<Subsidy />} />
        <Route path="/subsidy/:service" element={<SingleSubsidy />} />
        <Route path="/singlePageGallery" element={<SinglePageGallery />} />
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/owner" element={
          <ProtectedRoute>
            <WebAdmin />
          </ProtectedRoute>
        } />
        <Route path="/user/:uid" element={
          <ProtectedRoute>
            <SingleUser />
          </ProtectedRoute>
        } />
        <Route path="/team/:uid" element={
          <ProtectedRoute>
            <SingleTeam />
          </ProtectedRoute>
        } />
        <Route path="/user" element={
          <ProtectedRoute>
            <NewUser />
          </ProtectedRoute>
        } />
        <Route path="/team" element={
          <ProtectedRoute>
            <Team />
          </ProtectedRoute>
        } />
        <Route path="/team-customer/:customerId" element={
          <ProtectedRoute>
            <TeamCustomer />
          </ProtectedRoute>
        } />
        {/* <Route path="/owner" element={<Owner />} />
        <Route path="/owner/:district/:number" element={<Office />} />
        <Route path="/portal/office/:number" element={<Office />} />
        <Route path="/owner/:district/:number/:phone" element={<UserPage />} />
        <Route path="/portal/user/:phone/:number" element={<UserPage />} />
        <Route path="/signIn" element={<SignIn />} /> */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
